import { EMPTY_ARRAY } from '@e-socna/empty';

import { ServiceUsagesGroupsLayout } from './GroupsLayout';
import type {
  ServiceUsagesGroupsLayoutProps,
  ServiceUsagesLayoutGroup,
} from './GroupsLayout';
import { ServiceUsages } from '.';
import type { ServiceUsagesType } from './types/props.type';

export interface FrozenServiceUsagesGroup extends ServiceUsagesLayoutGroup {
  readonly serviceUsages: ServiceUsagesType<false>;
}

type Props = Omit<
  ServiceUsagesGroupsLayoutProps,
  'optionGroupsSelection' | 'showInheritanceAlert'
> &
  Readonly<{
    consultResolvableServiceInNewTab: boolean;
    groups: readonly FrozenServiceUsagesGroup[];
  }>;

// The groups of a quotation snapshot, shown like a live pricing but read only:
// carried by the mission, they inherit nothing.
export const FrozenServiceUsagesGroups = ({
  additionalTotalGroups = EMPTY_ARRAY,
  consultResolvableServiceInNewTab,
  groups,
  leadingContent,
  totalCalculation,
  ...layoutProps
}: Readonly<Props>) =>
  groups.length || additionalTotalGroups.length ? (
    <ServiceUsagesGroupsLayout
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...layoutProps}
      additionalTotalGroups={additionalTotalGroups}
      groups={groups}
      leadingContent={leadingContent}
      // eslint-disable-next-line react/jsx-no-bind
      renderGroupUsages={(group, slots) => (
        <ServiceUsages<false>
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...slots}
          consultResolvableServiceInNewTab={consultResolvableServiceInNewTab}
          editionMode={false}
          isInResolvableMode={false}
          serviceUsages={group.serviceUsages}
        />
      )}
      showInheritanceAlert={false}
      totalCalculation={totalCalculation}
    />
  ) : (
    <>
      {leadingContent}
      <ServiceUsages<false>
        consultResolvableServiceInNewTab={consultResolvableServiceInNewTab}
        editionMode={false}
        isInResolvableMode={false}
        serviceUsages={EMPTY_ARRAY}
        showInheritanceAlert={false}
        totalCalculation={totalCalculation}
      />
    </>
  );
